export var UrlSource;
(function (UrlSource) {
    UrlSource["URL"] = "url";
    UrlSource["BASE"] = "base";
    UrlSource["SKIN"] = "skin";
    UrlSource["CSS"] = "css";
    UrlSource["JS"] = "js";
    UrlSource["ASSETS"] = "assets";
    UrlSource["ARTICLES"] = "articles";
    UrlSource["ARTICLES_NO_IM"] = "articles-noIM";
    UrlSource["CDN"] = "cdn";
    UrlSource["CDN_NO_IM"] = "cdn-noIM";
    UrlSource["MEDIA"] = "media";
    UrlSource["MEDIA_NO_IM"] = "media-noIM";
    UrlSource["CAMPAIGN"] = "campaign";
    UrlSource["CAMPAIGN_NO_IM"] = "campaign-noIM";
    UrlSource["CHEETAH_CAMPAIGN"] = "cheetah-campaign";
    UrlSource["AWS_S3"] = "aws-s3";
    UrlSource["NOTIFICATION_STATUS"] = "notification_status";
    UrlSource["APP_TRACKING"] = "app_tracking";
    UrlSource["ARTICLES_VIDEOS"] = "articlesVideos";
    UrlSource["ARTICLES_VIDEOS_NO_IM"] = "articlesVideos-noIM";
    UrlSource["BRAND_LOGO"] = "brand-logo";
})(UrlSource || (UrlSource = {}));
